import type { TFunction } from "i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

export const operationTypeOptions = (t: TFunction) =>
  (["LOAD", "UNLOAD"] as const).map((type) => ({
    label: t(
      `${DRYBULK_CARGO_OPS_LANG_BASE}.add.operation-type-${type === "LOAD" ? "loading" : "unloading"}`,
    ),
    value: type,
  }));
